import React from "react";
import { Archive } from "lucide-react";
import type { Localizer } from "@/main/react/Types";

/**
 * `GROUP-84` (settle r42 A4; design `designs/01-now/2026-09-29-group-archive-design.md` §1.8): the one line an
 * archived group's page carries on every accessible section. C63 copy verbatim (`group.archive.banner`). A status,
 * not an alert: nothing went wrong, the owner chose this and can restore it. Flat-X: the hairline border is the
 * elevation, no shadow.
 */
export default function GroupArchivedBanner({ localizer }: { localizer: Localizer }) {
    return (
        <div
            role="status"
            data-playwright-id="group-archived-banner"
            className="flex min-w-0 items-center gap-2 rounded-xl border border-border bg-muted/40 px-3 py-2 text-sm leading-5 text-foreground"
        >
            <Archive aria-hidden="true" className="size-4 shrink-0 text-muted-foreground" />
            <span className="min-w-0">{localizer("group.archive.banner")}</span>
        </div>
    );
}
